import React from 'react';
import { investedProject } from '../dashboard/dashboard.module';
import InvestedProjects from '../shared/investedProjects/investedProjects';
import { Container } from '@material-ui/core';
import CarbonCreditCard from '../carbonCreditCard/carbonCreditCard';
import banner_blog from '../../assets/images/blog/bannerBlog.png';
import EgreenCoinsSoon from '../egreenCoinsSoon/egreenCoinsSoon';

const Test = () => (
  <Container maxWidth="lg" style={{ marginTop: '50px' }}>
    <InvestedProjects
      srcInvestedProjects={investedProject}
      title_investedProjects="Bundled Solar Photovoltiac"
      country_investedProjects="Chile"
      nfts_investedProjects="Carbon Credits bought: 10"
      description_investedProjects="The Project Activity will support the new grid connected
        renewable energy of power plants in india"
      textPerformance="Project Perfromance"
      textCertificate="Generate Certificate"
    />
        <EgreenCoinsSoon />
    <CarbonCreditCard
      name="Name"
      ipfs={{ hash: 'HASH IPFS' }}
      blockchain={{ hash: 'hash Blockchain' }}
      imageCarbonCredit={banner_blog}
    />

    <div
      style={{
        width: '150px',
        height: '150px',
        marginBottom: 30,
        marginTop: 30,
      }}
    >
      <CarbonCreditCard
        name="Name"
        ipfs={{ hash: 'HASH IPFS', url: 'https://horizon-testnet.stellar.org' }}
        blockchain={{ hash: 'hash Blockchain', url: 'https://horizon-testnet.stellar.org' }}
      />
    </div>
  </Container>
);

export default Test;
